import { Infer, object, string } from "superstruct";

export const ReviewsApplicationConfigSchema = object({
    reviewsWidgetPlaceholder: string(),
    drawerWidgetPlaceholderSelector: string(),
    averageWidgetPlaceholderSelector: string(),
    listingAverageReviewsWidgetPlaceholderSelector: string(),
    reviewsProductPageWidgetPlaceholderSelector: string(),
    reviewsPageWidgetPlaceholderSelector: string(),
    reviewsSliderWidgetPlaceholderSelector: string(),
    reviewsGalleryWidgetPlaceholderSelector: string(),
    productReviewsMiniSliderWidgetPlaceholderSelector: string(),
    reviewsFormModalWidgetPlaceholderSelector: string(),
    reviewsEditFormModalWidgetPlaceholderSelector: string(),
    questionsFormModalWidgetPlaceholderSelector: string(),
    reviewsListHeaderWidgetPlaceholderSelector: string(),
    reviewsListWidgetPlaceholderSelector: string(),
    questionsListWidgetPlaceholderSelector: string(),
    reviewsTrustBadgeWidgetPlaceholderSelector: string(),
});

export type ReviewsApplicationConfigInterface = Infer<
    typeof ReviewsApplicationConfigSchema
>;
